// http://3.15.93.231/3plapi/user/list

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable()
export class ConfigApiDataService {
   url = environment.url;

   constructor(private http: HttpClient){}

    //GET LOB LIST
    public getLOBs(): Observable<any> {
        return this.http.get(`${this.url}lob/getLobs`)
    }

    //EDIT LOB
    public editLob(payload: any): Observable<any> {
        return this.http.post(`${this.url}lob/saveLob`, payload)
    }

    //GET SUPPLY LIST
    public getSupplies(): Observable<any> {
        return this.http.get(`${this.url}config/getSupplyConfigs`)
    }

    //EDIT SUPPLY
    public editSupply(payload: any): Observable<any> {
        return this.http.post(`${this.url}config/saveSupplyConfig`, payload)
    }

    //DELETE SUPPLY
    public deleteSupply(payload: any): Observable<any> {
        return this.http.post(`${this.url}config/deleteSupplyConfig`, payload)
    }

    //GET SCAN GROUP
    public getScanGroup(): Observable<any> {
        return this.http.get(`${this.url}spirit/getScanGroupDetails`)
    }

    //EDIT SCAN GROUP
    public editScanGroup(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/saveScanGroup`, payload)
    }

    //DELETE SCAN GROUP
    public deleteScanGroup(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/delete/${payload}`, payload)
    }

    //GET REPORT GROUP
    public getReportGroup(): Observable<any> {
        return this.http.get(`${this.url}spirit/getReportGroupDetails`)
    }

    //EDIT REPORT GROUP
    public editReportGroup(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/saveReportGroup`, payload)
    }

    //DELETE REPORT GROUP
    public deleteReportGroup(payload: any): Observable<any> {
        return this.http.post(`${this.url}spirit/deleteReportGroup/${payload}`, payload)
    }
}